import React, { useContext, useEffect } from 'react';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

import { CircularProgress } from '@mui/material';

import { appRoutes } from '@/routes/constants';
import getConnectorsConfiguration from '@/operator/shared/connectorsConfiguration';
import { PageStateDispatchContext } from '@/operator/components/general/multiStepForm/formStateContext';
import { PageStateActions } from '@/operator/components/general/multiStepForm/formStateReducer';
import { ConnectionType } from 'generated/graphql';

interface FormAutoSelectServiceProps {
    readonly onContinue: (system: string) => void;
    readonly connections: ConnectionType[];
    readonly loading: boolean;
    readonly connectionName: string;
    readonly hasBeenAutoCompletedStep1: boolean;
    readonly handleAutoCompleteStep1: () => void;
}

export function FormAutoSelectService({
    onContinue,
    connections,
    loading,
    connectionName,
    hasBeenAutoCompletedStep1,
    handleAutoCompleteStep1,
}: FormAutoSelectServiceProps) {
    const navigate = useOrgNavigate();

    const pageStateDispatch = useContext(PageStateDispatchContext);

    const connectorsConfiguration = getConnectorsConfiguration();

    const isOrgLoading = loading;

    useEffect(() => {
        if (isOrgLoading || hasBeenAutoCompletedStep1) {
            return;
        } else {
            handleAutoCompleteStep1();
            const connectorConfiguration = connectorsConfiguration.find(
                (connector) =>
                    connector.systemName.toLowerCase() ===
                    connectionName.toLowerCase(),
            );

            if (
                !connectorConfiguration?.enabled ||
                connectorConfiguration === undefined
            ) {
                return navigate(appRoutes.OPERATOR_ADMIN_CONNECTIONS);
            }

            pageStateDispatch?.({
                type: PageStateActions.SetSelectedConnector,
                value: connectorConfiguration.systemName,
            });
            onContinue(connectorConfiguration.systemName);
        }
    }, [isOrgLoading, hasBeenAutoCompletedStep1]);

    //Will autoselect and render loader while selecting to disrupt current steps in the future qe can refactor completly
    return (
        <div
            style={{
                width: `100%`,
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <CircularProgress
                style={{
                    width: '44px',
                    height: '44px',

                    marginTop: '68px',
                }}
            />
        </div>
    );
}
